<template>
  <div class="check-contenido">
    <div class="conjunto-titular">
      <p class="check-titular">{{titulo}}</p>
      <BotonInfoTooltip 
        :contenido='"<p>Resistencia</p> <p>La resistencia es la capacidad del virus para inhibir la acción del tratamiento antirretroviral.</p>"'
      />
      <button class="btn btn-sm boton-quitar-todos" @click="quitarPonerTodos">{{ quitar_poner_todos}}</button>
    </div>
    <div v-html="descripcion" class="check-descripcion"></div>
    <div class="check-contenedor-checkbox">
      <label class="checkbox" v-for="opcion in opciones" :key="opcion.id">
        <input type="checkbox" :value="opcion.id" v-model="checkeados">
        <span class="color" v-bind:style="{background: opcion.color}"></span>
        <span class="nombre">{{opcion.texto}}
        </span>
        <span class="span-info" v-if="Object.keys(diccionario_ayuda_info).includes(opcion.texto)">
          <BotonInfoTooltip 
          :contenido="diccionario_ayuda_info[opcion.texto]"/>
        </span>
      </label>
    </div>
  </div>
</template>
<script>
import BotonInfoTooltip from "@/components/utils/BotonInfoTooltip.vue";
import diccionario_ayuda_info from "@/assets/data/tooltips_tablero_clusters.json"
export default {
  name: 'CheckGeneral',
  components: {
    BotonInfoTooltip
  },
  props: {
    titulo: String,
    descripcion: String,
    opciones: Array,
    variable_store: String,
    funcion_store: String
  },
  data(){
    return {
      quitar_poner_todos: "Quitar todos",
      diccionario_ayuda_info: diccionario_ayuda_info
    }
  },
  mounted: function() {
    this.checkeados = this.opciones.map((d) => d.id)
  },
  methods: {
    quitarPonerTodos() {
      if(this.quitar_poner_todos == "Quitar todos"){
        this.quitar_poner_todos = "Ver todos";
        this.checkeados=[]
      }
      else{
        this.quitar_poner_todos = "Quitar todos";
        this.checkeados = this.opciones.map((d) => d.id)
      }
    },
  },
  computed: {
    checkeados: {
      get() {
        return this.$store.state[this.variable_store]
      },
      set(value) {
        this.$store.commit(this.funcion_store, value);

      }
    }
  },
}
</script>
<style scoped lang="scss">
$padding: $gap * .5;

.check-contenido {
  flex: 1 0;
  padding: $padding*.5 $padding;
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    border-radius: 10px;
    box-shadow: 0px 5px 5px -1px #dddddd;
    margin-bottom: $padding*.5;
  }
}
.conjunto-titular {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .boton-quitar-todos {
    background-color: var(--control-bg-color);
    border: 1px solid var(--control-color);
    color: var(--control-color);
  }
}
.check-descripcion {
  display: none;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: block;
    font-size: 16px;
    line-height: 1.1em;
    margin: $padding*.25 0 $padding*.5;
  }
}
div.check-contenedor-checkbox {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 10px;
  label.checkbox {
    margin: 0 0 10px 0;
    input {
      display: inline-block;
      margin-right: 2px;
    }
    .color {
      border-radius: 50%;
      width: 24px;
      min-width: 24px;
      height: 24px;
      display: inline-block;
    }
    .nombre {
      font-size: 12px;
      line-height: 1.1em;
    }
    .span-info {
      margin: 0;
    }
  }
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: block;
    margin-top: 15px;
    label.checkbox {
      .nombre {
        font-size: 16px;
      }
    }
  }
}
</style>
